import { type FC } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { getUser } from "@/store/slices/auth";
import { useAppSelector } from "@/store/hooks";

const TeacherLayout: FC = () => {
  const navigate = useNavigate();
  const user = useAppSelector(getUser);
  // const dispatch = useAppDispatch();

  // const handleLogout = (): void => {
  //   // Remove cookie
  //   dispatch(clearUser());
  //   navigate("/");
  // };
  if (!user) {
    navigate("/login");
  }
  if (user && (user.role === "super_admin" || user.role === "user")) {
    //Navigate to restricted route to 404
    navigate("/notFound");
  }

  return <Outlet />;
};

export default TeacherLayout;
